import { useTranslation } from "react-i18next";
import { Fade } from "react-reveal"
import { useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import validateForm from "../../validation";
import { useRef, useState } from "react";

const ContactForm = () => {
  const { t } = useTranslation();
  const location = useLocation();


  const formRef = useRef();
  const [formData, setFormData] = useState({
    message: "",
    to: "appsteroffice@appstersolutions.com"
  });
  const [formSubmited, setFormSubmited] = useState(false);

  const sendContactMessage = (event) => {
    if (!validateForm(formRef.current)) return;
    const _formData = new FormData();
    for (var i in formData) {
      _formData.append(i, formData[i]);
    }
    fetch('https://contactform.appsterdevelopment.co.rs/mail_cv.php', { method: 'POST', body: _formData }).then(res => res.text());
    setFormSubmited(true);
  };

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };


  // const handleMessage = (event) => {
  //   event.preventDefault()
  //   event.target.reset()
  //   toast.success("Thanks for Your Message")
  // }


  return (
    <>
      <Fade className="fadeInLeft" delay={300}>
        <div className="contact-section-form">
          <div className="section-title mb-20 text-center text-md-start">
            <h2>{t('get_in_touch')}</h2>
          </div>
          {!formSubmited && (
            <div
              onSubmit={(e) => e.preventDefault()}
              className="form-style-one"
              action="#"
              name="contact-form"
              ref={formRef}
            >
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control"
                      defaultValue=""
                      placeholder={`*${t('full_name')}`}
                      required
                      onChange={changeHandler}
                    />
                  </div>
                </div>
                <div className="col-sm-6">
                  <div className="form-group">
                    <input
                      type="text"
                      id="phone"
                      name="phoneNumber"
                      className="form-control"
                      defaultValue=""
                      placeholder={`*${t('phone_number')}`}
                      required
                      onChange={changeHandler}
                    />

                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <input
                      type="email"
                      id="emailid"
                      name="email"
                      className="form-control"
                      defaultValue=""
                      placeholder={`*${t('email')}`}
                      required
                      onChange={changeHandler}
                    />
                  </div>
                </div>
                {location.pathname === "/careers" && (
                  <div className="col-12">
                    <div className="form-group">
                      <label htmlFor="email">Your CV</label>
                      <input type="file" id="cv" name="cv" className="form-control" placeholder="Email" autoComplete='off' required />
                    </div>
                  </div>
                )}
                <div className="col-sm-12">
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows={3}
                      placeholder={`*${t('message')}`}
                      required
                      defaultValue={""}
                      onChange={changeHandler}
                    />
                  </div>
                </div>
                <div className="col-sm-12 text-center text-md-start">
                  <button type="submit" className="theme-btn " onClick={sendContactMessage}>{t('send_message')}</button>
                </div>
              </div>
            </div>
          )}
          {formSubmited && (
            <h5 className="w-100 my-5 text-black" >{t('mail_sent')}</h5>
          )}
        </div>
      </Fade>
    </>
  )
}
export default ContactForm;